"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SearchInput = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _reactRouterDom = require("react-router-dom");
var _constants = require("../../constants");
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _OriIcon = require("../common/OriIcon/OriIcon");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const SearchInput = (param)=>{
    let { inputValue, setInputValue } = param;
    const { translations } = (0, _hooks.useTranslations)();
    const { register, handleSubmit, reset } = (0, _reactHookForm.useForm)();
    const { query, resetSearchResults } = (0, _contexts.useSearchResultContext)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { getTestId } = (0, _testidGenerator.default)();
    const onSubmit = (0, _react.useCallback)(async (param)=>{
        let { search } = param;
        if (search && search !== query) {
            resetSearchResults();
            void navigate(_constants.SiteMap.Search.to(search));
        }
    }, [
        navigate,
        query,
        resetSearchResults
    ]);
    const onReset = (0, _react.useCallback)(()=>{
        setInputValue('');
        reset();
    }, [
        reset,
        setInputValue
    ]);
    const onChange = (0, _react.useCallback)((event)=>{
        if (event.target.value.length <= _constants.MAX_QUERY_LENGTH) {
            setInputValue(event.target.value);
        }
    }, [
        setInputValue
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Root, {
        "data-testid": getTestId('top-banner-question-input'),
        onSubmit: handleSubmit(onSubmit),
        onReset: onReset,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.InputBase, {
            autoFocus: true,
            name: "search",
            placeholder: translations.searchInSupportCenter,
            inputProps: register('search'),
            endAdornment: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.InputAdornment, {
                position: "end",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.IconButton, {
                    "aria-label": "Clear search field",
                    type: "reset",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_OriIcon.OriIcon, {
                        name: "cross",
                        size: "2.33rem",
                        color: "#ccc"
                    })
                })
            }),
            startAdornment: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.InputAdornment, {
                position: "start",
                onClick: handleSubmit(onSubmit),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_OriIcon.OriIcon, {
                    name: "search",
                    size: "2.33rem"
                })
            }),
            value: inputValue,
            onChange: onChange
        })
    });
};
exports.SearchInput = SearchInput;
